<template>
    <div class="interview-tiles" v-if="interviews.length > 0">
        <h3 style="position: absolute; top: 0; left: 0">Interview Transcripts</h3>
        <a href="#" @click.prevent="openInterviewModal(interview)" v-for="interview in interviews" :key="interview.id">
            <span class="interview-title">
                <i class="material-icons">people</i>
                <span>{{ interview.title }}</span>
            </span>
            <dl class="interview-details">
                <dt>Bias</dt>
                <dd><EditorText class="small" :value="interview.sourceBias" /></dd>
                <dt>Overlap Range</dt>
                <dd><EditorText class="small" :value="interview.overlapRange" /></dd>
                <dt>Relevance</dt>
                <dd><EditorText class="small" :value="interview.relevance" /></dd>
            </dl>
        </a>
    </div>
</template>
<script>
import EditorText from '../inputs/RichTextEditor/EditorText.vue'

export default {
    components: {
        EditorText,
    },
    props: {
        interviews: {
            type: Array,
            required: true,
        },
    },
    methods: {
        openInterviewModal(interview) {
            this.$emit('open', interview)
        },
    },
}
</script>
<style>
.interview-tiles {
    grid-area: interviews;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(420px, auto));
    gap: 24px;
    padding-top: 40px;
    position: relative;

    & > a {
        background-color: var(--color-primary-100);
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        border-radius: 5px;

        .interview-title {
            align-items: center;
            display: flex;
            gap: 8px;

            i {
                flex-grow: 0;
            }

            span {
                flex-grow: 1;
                font-size: 16px;
                font-weight: bold;
            }
        }

        .interview-details {
            display: grid;
            grid-template-columns: 1fr 2fr;
            grid-template-rows: 1fr 1fr auto;

            dt {
                font-weight: bold;
            }
        }
    }
}
</style>
